module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-form', [_c('v-container', [_c('v-col', [_c('v-text-field', {
    attrs: {
      "name": "firstName",
      "label": "First Name",
      "id": "firstName",
      "dense": "",
      "outlined": "",
      "hide-details": "auto",
      "autocomplete": "off"
    },
    model: {
      value: (_vm.value.first_name),
      callback: function($$v) {
        _vm.$set(_vm.value, "first_name", $$v)
      },
      expression: "value.first_name"
    }
  })], 1), _vm._v(" "), _c('v-col', [_c('v-text-field', {
    attrs: {
      "name": "lastName",
      "label": "Last Name",
      "id": "lastName",
      "dense": "",
      "outlined": "",
      "hide-details": "auto",
      "autocomplete": "off"
    },
    model: {
      value: (_vm.value.last_name),
      callback: function($$v) {
        _vm.$set(_vm.value, "last_name", $$v)
      },
      expression: "value.last_name"
    }
  })], 1), _vm._v(" "), _c('v-col', [_c('v-text-field', {
    attrs: {
      "name": "email",
      "label": "Email",
      "id": "email",
      "dense": "",
      "outlined": "",
      "hide-details": "auto",
      "autocomplete": "off"
    },
    model: {
      value: (_vm.value.email),
      callback: function($$v) {
        _vm.$set(_vm.value, "email", $$v)
      },
      expression: "value.email"
    }
  })], 1), _vm._v(" "), _c('v-col', [_c('v-btn', {
    attrs: {
      "color": "success",
      "block": "",
      "dark": ""
    },
    nativeOn: {
      "click": function($event) {
        return _vm.formSubmitHandler.apply(null, arguments)
      }
    }
  }, [_vm._v("Create New User")])], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-317ca876"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/app/appComponents/permissions/forms/UserForm.vue
// module id = 1849
// module chunks = 0